import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'

import MetadataWrapper from 'components/metadata-wrapper'

import styles from './widget-maker.css'

const cleanOption = option => option.replace('-', ' ')

const WidgetMakerOption = ({ label, paragraph, value, name, options, onChange }) => (
  <MetadataWrapper label={label}>
    <p styleName="paragraph" dangerouslySetInnerHTML={{ __html: paragraph }} />
    {options.map((option, i) => (
      <span key={i}>
        <input
          id={`widget-${option}`}
          checked={value === option}
          name={name}
          type="radio"
          value={option}
          onChange={e => onChange(name, e.target.value)}
        />
        <label htmlFor={`widget-${option}`} styleName="label">{cleanOption(option)}</label>
      </span>
    ))}
  </MetadataWrapper>
)

WidgetMakerOption.propTypes = {
  label: PropTypes.string,
  paragraph: PropTypes.string,
  value: PropTypes.string,
  name: PropTypes.string,
  options: PropTypes.array,
  onChange: PropTypes.func,
}

export default CSSModules(WidgetMakerOption, styles)



/** WEBPACK FOOTER **
 ** ./src/components/widget-maker/widget-maker-option.js
 **/